// @flow
/** @jsx jsx */

import { memoize } from 'lodash';

import { SearchableSelectField } from '@zapier/common-components';
import { jsx } from '@emotion/core';
import { weightedSearch } from '@zapier/common-utils';

import countries from './countries';

const countrySearch = memoize(weightedSearch);

type Props = {
  /** Show Error Styling */
  hasError?: boolean,
  /** Id of label element */
  labelId?: string,
  /** Handle item change */
  onChange: (event: SyntheticEvent<HTMLInputElement> | string) => void,
  /** Initial value */
  value?: string,
};

const CountrySelect = ({ hasError, labelId, onChange, value }: Props) => {
  const initialValue = value ? countries.find(c => c.code === value) : null;
  return (
    <SearchableSelectField
      autoComplete="shipping country-name"
      filterItems={countrySearch}
      getKeyForItem={item => item.code}
      getLabelForItem={item => item.name}
      hasError={hasError}
      initialSelectedItem={initialValue}
      items={countries}
      labelId={labelId}
      menuAriaLabel="address countries"
      name="country"
      onChange={onChange}
      placeholder="Select a country..."
    />
  );
};

export default CountrySelect;
